import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import {
  valdiatePage,
  processStrWithSpaceAndSpecalChars,
  processNum
} from "../../global";
import {
  saveBanner,
  getBanners,
  GetImagesForView,
  UpdateBanner,
} from "../../services/portalbannerservice";
import { setLoading } from "../../redux/appSlice";

const PortalBanner = () => {
  const dispatch = useDispatch();
  const { userInfo, accounts } = useSelector((state) => state.appData);

  const history = useHistory();

  const d = {
    id: 0,
    Title: "",
    TitleDescription: "",
    BannerText: "",
    BgImageName: "",
    BgImageOpacity: 0.5,
    IsBgImage: false,
    status: false,
    FooterImageName: "",
    FooterImageOpacity: 0.5,
    IsFooterImage: false,
    FontId: 1,
    FontColor: "",
    BackgroundColor: "",
    BgColorOpacity: 0.5,
    BgImageSavedFile: "",
    FooterImageSavedFile: "",
    IsActive: false,
  };

  const [data, setData] = useState(d);
  const [viewType, setViewType] = useState("list");
  const [grid, setGrid] = useState([]);
  const [selectedBgImage, setSelectedBGImage] = useState(null);
  const [selectedFooterImage, setSelectedFooterImage] = useState(null);

  useEffect(() => {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      if (!valdiatePage('/portalbanner')) {
          history.push('/login');
      }
      return () => {
          source.cancel('Operation canceled by the user.');
      }
  }, []);

  useEffect(() => {
    if (viewType === "list") {
      (async function () {
        dispatch(setLoading({ data: true }));
        const rs = await getBanners();
        dispatch(setLoading({ data: false }));
        if (rs.ok) {
          setGrid(rs.data);
        }
      })();
    }
  }, [viewType]);

  const updateData = (key, val) => {
    setData((prev) => {
      return { ...prev, [key]: val };
    });
  };

  const onAdd = () => {
    setViewType("add");
    setData(d);
  };

  function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  };

  const onSave = async () => {
    if (!data.Title || data.Title.trim() === "") {
      alert("Enter Title");
      return;
    }

    // if (!data.TitleDescription || data.TitleDescription.trim() === "") {
    //   alert("Enter Title Description");
    //   return;
    // }

    // if (!data.BannerText || data.BannerText.trim() === "") {
    //   alert("Enter Banner Text");
    //   return;
    // }

    // if (!data.BgImageName || data.BgImageName.trim() === "") {
    //   alert("Enter Background Image Name.");
    //   return;
    // }

    if (!data.BgImageOpacity) {
      alert("Enter Background Image Opacity.");
      return;
    }

    // if (!data.FooterImageName || data.FooterImageName.trim() === "") {
    //   alert("Enter Footer Image Opacity.");
    //   return;
    // }

    if (!data.FooterImageOpacity) {
      alert("Enter Footer Image Opacity.");
      return;
    }

    // if (!data.FontColor || data.FontColor.trim() === "") {
    //   alert("Enter Font Color.");
    //   return;
    // }

    // if (!data.BackgroundColor || data.BackgroundColor.trim() === "") {
    //   alert("Enter Background Color.");
    //   return;
    // }

    if (!data.BgColorOpacity) {
      alert("Enter Background Color Opacity.");
      return;
    }

    if (data.IsBgImage && selectedBgImage === null) {
      alert("Select Background Image.");
      return;
    }

    if (data.IsFooterImage && selectedFooterImage === null) {
      alert("Select Footer Image.");
      return;
    }

    const formData = new FormData();
    formData.append("Title", data.Title);
    formData.append("TitleDescription", String(!data.TitleDescription ? "": data.TitleDescription));
    formData.append("BannerText", String(!data.BannerText ? "": data.BannerText));
    formData.append("BgImageName", String(!data.BgImageName ? "": data.BgImageName));

    formData.append("imageFile", selectedBgImage);

    formData.append("BgImageOpacity", data.BgImageOpacity);
    formData.append("IsBgImage", data.IsBgImage);
    formData.append("status", data.status);
    formData.append("FooterImageName", String(!data.FooterImageName ? "": data.FooterImageName));

    formData.append("footerFile", selectedFooterImage);

    formData.append("FooterImageOpacity", data.FooterImageOpacity);
    formData.append("IsFooterImage", data.IsFooterImage);
    formData.append("FontId", data.FontId);
    formData.append("FontColor", String(!data.FontColor ? "": data.FontColor));
    formData.append("BackgroundColor", String(!data.BackgroundColor ? "": data.BackgroundColor));
    formData.append("BgColorOpacity", data.BgColorOpacity);

    dispatch(setLoading({ data: true }));
    const rs = await saveBanner(formData);
    dispatch(setLoading({ data: false }));
    alert(rs.msg);
    if (rs.ok) {
      setData(d);
      setSelectedBGImage(null);
      setSelectedFooterImage(null);
      setViewType("list");
    }
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const onEdit = async (x) => {
    dispatch(setLoading({ data: true }));
    const rs = await GetImagesForView(x.id);
    dispatch(setLoading({ data: false }));
    if (rs.sts == 0) {
      setData((prev) => {
        return {
          ...prev,
          id: x.id,
          Title: x.Title,
          TitleDescription: x.TitleDescription,
          BannerText: x.BannerText,
          BgImageName: x.BgImageName,
          BgImageOpacity: x.BgImageOpacity.toFixed(1),
          IsBgImage: x.IsBgImage,
          status: x.status,
          FooterImageName: x.FooterImageName,
          FooterImageOpacity: x.FooterImageOpacity.toFixed(1),
          IsFooterImage: x.IsFooterImage,
          FontId: x.FontId,
          FontColor: x.FontColor,
          BackgroundColor: x.BackgroundColor,
          BgColorOpacity: x.BgColorOpacity.toFixed(1),
          BgImageSavedFile: rs.data.BgImageSavedFile,
          FooterImageSavedFile: rs.data.FooterImageSavedFile,
        };
      });

      if (rs.data.BgImageSavedFile) {
        var file = dataURLtoFile(
          `data:text/plain;base64,${rs.data.BgImageSavedFile}`,
          "hello.jpeg"
        );
        setSelectedBGImage(file);
      } else {
        setSelectedBGImage(null);
      }

      if (rs.data.FooterImageSavedFile) {
        var file = dataURLtoFile(
          `data:text/plain;base64,${rs.data.FooterImageSavedFile}`,
          "hello.jpeg"
        );
        setSelectedFooterImage(file);
      } else {
        setSelectedFooterImage(null);
      }

      setViewType("edit");
    } else {
      alert(rs.msg);
    }
  };


  const onUpdate = async () => {
    if (!data.Title || data.Title.trim() === "") {
      alert("Enter Title");
      return;
    }

    // if (!data.TitleDescription || data.TitleDescription.trim() === "") {
    //   alert("Enter Title Description");
    //   return;
    // }

    // if (!data.BannerText || data.BannerText.trim() === "") {
    //   alert("Enter Banner Text");
    //   return;
    // }

    // if (!data.BgImageName || data.BgImageName.trim() === "") {
    //   alert("Enter Background Image Name.");
    //   return;
    // }

    if (!data.BgImageOpacity) {
      alert("Enter Background Image Opacity.");
      return;
    }

    // if (!data.FooterImageName || data.FooterImageName.trim() === "") {
    //   alert("Enter Footer Image Opacity.");
    //   return;
    // }

    if (!data.FooterImageOpacity) {
      alert("Enter Footer Image Opacity.");
      return;
    }

    // if (!data.FontColor || data.FontColor.trim() === "") {
    //   alert("Enter Font Color.");
    //   return;
    // }

    // if (!data.BackgroundColor || data.BackgroundColor.trim() === "") {
    //   alert("Enter Background Color.");
    //   return;
    // }

    if (!data.BgColorOpacity) {
      alert("Enter Background Color Opacity.");
      return;
    }

    if (data.IsBgImage && selectedBgImage === null) {
      alert("Select Background Image.");
      return;
    }

    if (data.IsFooterImage && selectedFooterImage === null) {
      alert("Select Footer Image.");
      return;
    }

    const formData = new FormData();
    formData.append("Title", data.Title);
    formData.append("TitleDescription", String(!data.TitleDescription ? "": data.TitleDescription));
    formData.append("BannerText", String(!data.BannerText ? "": data.BannerText));
    formData.append("BgImageName", String(!data.BgImageName ? "": data.BgImageName));

    formData.append("imageFile", selectedBgImage);

    formData.append("BgImageOpacity", data.BgImageOpacity);
    formData.append("IsBgImage", data.IsBgImage);
    formData.append("status", data.status);
    formData.append("FooterImageName", String(!data.FooterImageName ? "": data.FooterImageName));

    formData.append("footerFile", selectedFooterImage);

    formData.append("FooterImageOpacity", data.FooterImageOpacity);
    formData.append("IsFooterImage", data.IsFooterImage);
    formData.append("FontId", data.FontId);
    formData.append("FontColor", String(!data.FontColor ? "": data.FontColor));
    formData.append("BackgroundColor", String(!data.BackgroundColor ? "": data.BackgroundColor));
    formData.append("BgColorOpacity", data.BgColorOpacity);

    dispatch(setLoading({ data: true }));
    const rs = await UpdateBanner(data.id, !data.IsActive, formData);
    dispatch(setLoading({ data: false }));
    alert(rs.msg);
    if (rs.ok) {
      setData(d);
      setSelectedBGImage(null);
      setSelectedFooterImage(null);
      setViewType("list");
    }
  };

  return (
    userInfo && (
      <section className="section">
        <div className="section-header">
          <h1>Portal Banners</h1>
        </div>
        {viewType === "list" ? (
          <>
            <div className="card" style={{ padding: 10 }}>
              <div style={{ textAlign: "right" }}>
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={onAdd}
                >
                  Add Banner
                </button>
              </div>
              <div className="table-responsive">
                {
                  <>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Title Description</th>
                          <th>Banner Text</th>
                          <th>Bg Image Opacity</th>
                          <th>Bg Image Enable</th>
                          <th>Footer Image Opacity</th>
                          <th>Footer Image Enable</th>
                          {/* <th>Fonts</th> */}
                          <th>Font Color</th>
                          <th>Background Color</th>
                          <th>Bg Color Opacity</th>
                          <th>Status</th>
                          {/* <th>IsActive</th> */}
                          <th>
                            <b>Edit</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {grid && grid.length > 0 ? (
                          grid.map((x, index) => (
                            <tr key={index}>
                              <td>{x.Title}</td>
                              <td>{!x.TitleDescription? '' : truncate(x.TitleDescription,30)}</td>
                              <td>{!x.BannerText? '' : truncate(x.BannerText,30)}</td>
                              <td>{x.BgImageOpacity?.toFixed(1)}</td>
                              <td>{x.IsBgImage ? "Active" : "InActive"}</td>
                              <td>{x.FooterImageOpacity?.toFixed(1)}</td>
                              <td>{x.IsFooterImage ? "Active" : "InActive"}</td>
                              {/* <td>{x.FontId}</td> */}
                              <td>{x.FontColor}</td>
                              <td>{x.BackgroundColor}</td>
                              <td>{x.BgColorOpacity?.toFixed(1)}</td>
                              <td>{x.status ? "Active" : ""}</td>
                              {/* <td>{x.IsActive ? "Active" : "InActive"}</td> */}
                              <td>
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => onEdit(x)}
                                  >
                                    Edit
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td>No Banners Found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </>
                }
              </div>
            </div>
          </>
        ) : viewType === "edit" ? (
          <div className="card" style={{ padding: 10 }}>
            <div style={{ textAlign: "right" }}>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => setViewType("list")}
              >
                Back
              </button>
            </div>

            <div className="row mt-3">
              <div className="col-lg-3 col-sm-12">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.Title}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) => updateData("Title", e.target.value)}
                />
              </div>
              <div className="col-lg-9 col-sm-12">
                <label>Title Description</label>
                <textarea
                  className="form-control"
                  value={data.TitleDescription == null ? "": data.TitleDescription}
                  maxLength={1000}
                  onChange={(e) =>
                    updateData("TitleDescription", e.target.value)
                  }
                ></textarea>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-12 col-sm-12">
                <label>Banner Text</label>
                <textarea
                  className="form-control"
                  value={data.BannerText == null ? "": data.BannerText}
                  maxLength={2000}
                  onChange={(e) => updateData("BannerText", e.target.value)}
                ></textarea>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-3 col-sm-12">
                <label style={{ whiteSpace: "nowrap" }}>Delete Banner</label>
                <br />
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={data.IsActive}
                    onChange={(e) => {
                      if(window.confirm("Are you sure!\nYou want to Delete this banner.")) {
                        updateData("IsActive", true);
                      } else {
                        updateData("IsActive", false);
                      }
                    }}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="col-lg-3 col-sm-12">
                <label style={{ whiteSpace: "nowrap" }}>Active/InActive</label>
                <br />
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={data.status}
                    onChange={(e) => updateData("status", e.target.checked)}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-3 col-sm-12">
                <label>Background Image Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.BgImageName}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) => updateData("BgImageName", e.target.value)}
                />
              </div>

              <div className="col-lg-3 col-sm-12">
                <label>Background Image Opacity</label>
                <input
                  title="The higher the value, the more transparent. So if an element is given an opacity of 1 or more than 1 , it would be invisible."
                  type="text"
                  className="form-control"
                  value={data.BgImageOpacity}
                  onInput={processNum}
                  maxLength={3}
                  placeholder="Enter value between 0.0 to 1.0"
                  onChange={(e) => updateData("BgImageOpacity", e.target.value)}
                />
              </div>

              <div className="col-lg-3 col-sm-12">
                <label>Footer Image Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.FooterImageName}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) =>
                    updateData("FooterImageName", e.target.value)
                  }
                />
              </div>

              {/* <div className="col-lg-3 col-sm-12">
                <label>Footer Image Opacity</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.FooterImageOpacity}
                  onInput={processNum}
                  maxLength={3}
                  placeholder="Enter value between 0.0 to 1.0"
                  onChange={(e) =>
                    updateData("FooterImageOpacity", e.target.value)
                  }
                />
              </div> */}
            </div>

            <div className="row mt-3">
              <div className="col-lg-3 col-sm-12">
                <label>Font Color</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.FontColor}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) => updateData("FontColor", e.target.value)}
                />
              </div>

              <div className="col-lg-3 col-sm-12">
                <label>BackGround Color</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.BackgroundColor}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) =>
                    updateData("BackgroundColor", e.target.value)
                  }
                />
              </div>

              <div className="col-lg-3 col-sm-12">
                <label>Background Color Opacity</label>
                <input
                  title="The lower the value, the more transparent. So if an element is given an opacity of 0 , it would be invisible."
                  type="text"
                  className="form-control"
                  value={data.BgColorOpacity}
                  onInput={processNum}
                  maxLength={3}
                  placeholder="Enter value between 0.0 to 1.0"
                  onChange={(e) => updateData("BgColorOpacity", e.target.value)}
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-6 col-sm-12">
                <div className="col-lg-1 col-sm-12">
                  <label style={{ whiteSpace: "nowrap" }}>
                    Background Image
                  </label>
                  <br />
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={data.IsBgImage}
                      onChange={(e) =>
                        updateData("IsBgImage", e.target.checked)
                      }
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
                {selectedBgImage && (
                  <div className="col-lg-6 col-sm-12 mt-3">
                    <label>Display and Upload Background Image</label>
                    <div>
                      <img
                        alt="Bg Image"
                        width={"250px"}
                        src={URL.createObjectURL(selectedBgImage)}
                      />
                      <br />
                      <button onClick={() => setSelectedBGImage(null)}>
                        Remove
                      </button>
                    </div>
                  </div>
                )}
                {data.IsBgImage && (
                  <div className="col-lg-6 col-sm-12 mt-3">
                    <br />
                    <br />

                    <input
                      type="file"
                      name="myImage"
                      onChange={(e) => {
                        var fileInput = e;
                        var filePath = e.target.value;
                        // Allowing file type
                        var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
                        if (!allowedExtensions.exec(filePath)) {
                          alert("Invalid file type");
                          fileInput.target.value = "";
                          return false;
                        }

                        const fi = e.target;
                        // Maximum file size is 4 mb
                        if (fi.files.length > 0) {
                          for (let i = 0; i <= fi.files.length - 1; i++) {
                            const fsize = fi.files.item(i).size;
                            const file = Math.round(fsize / 1024);
                            // The size of the file.
                            if (file >= 4096) {
                              alert(
                                "File too Big, please select a file less than 4mb"
                              );
                              return false;
                            }
                          }
                        }

                        //checking dimention for banner and footer

                        // var img = document.createElement("img");
                        // img.src = URL.createObjectURL(e.target.files[0]);

                        // img.onload = function (event) {
                        //   console.log({ width: img.width, height: img.height });
                        //   console.log('inner')
                        //   if(img.height != 667 && img.width != 1000 ) {
                        //     alert("Wrong Image dimentions, valid image dimention is 1000/667.");
                        //     setSelectedBGImage(null);
                        //     return false;
                        //   }
                        //   setSelectedBGImage(e.target.files[0]);
                        // };

                        setSelectedBGImage(e.target.files[0]);
                      }}
                    />
                  </div>
                )}
              </div>

              <div className="col-lg-6 col-sm-12">
                <div className="col-lg-6 col-sm-12">
                  <label style={{ whiteSpace: "nowrap" }}>Footer Image</label>
                  <br />
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={data.IsFooterImage}
                      onChange={(e) =>
                        updateData("IsFooterImage", e.target.checked)
                      }
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
                {selectedFooterImage && (
                  <div className="col-lg-6 col-sm-12 mt-3">
                    <label>Display and Upload Footer Image</label>
                    <div>
                      <img
                        alt="not found"
                        width={"250px"}
                        src={URL.createObjectURL(selectedFooterImage)}
                      />
                      <br />
                      <button onClick={() => setSelectedFooterImage(null)}>
                        Remove
                      </button>
                    </div>
                  </div>
                )}
                {data.IsFooterImage && (
                  <div className="col-lg-6 col-sm-12 mt-3">
                    {/* <label>Upload and Display New Footer Image</label>
                    {selectedFooterImage && (
                      <div>
                        <img
                          alt="not found"
                          width={"250px"}
                          src={URL.createObjectURL(selectedFooterImage)}
                        />
                        <br />
                        <button onClick={() => setSelectedFooterImage(null)}>
                          Remove
                        </button>
                      </div>
                    )} */}

                    <br />
                    <br />

                    <input
                      type="file"
                      name="myImage"
                      onChange={(e) => {
                        var fileInput = e;
                        var filePath = e.target.value;
                        // Allowing file type
                        var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
                        if (!allowedExtensions.exec(filePath)) {
                          alert("Invalid file type");
                          fileInput.target.value = "";
                          return false;
                        }

                        const fi = e.target;
                        // Maximum file size is 4 mb
                        if (fi.files.length > 0) {
                          for (let i = 0; i <= fi.files.length - 1; i++) {
                            const fsize = fi.files.item(i).size;
                            const file = Math.round(fsize / 1024);
                            // The size of the file.
                            if (file >= 4096) {
                              alert(
                                "File too Big, please select a file less than 4mb"
                              );
                              return false;
                            }
                          }
                        }

                        //checking dimention for banner and footer

                        // var img = document.createElement("img");
                        // img.src = URL.createObjectURL(e.target.files[0]);

                        // img.onload = function (event) {
                        //   console.log({ width: img.width, height: img.height });
                        //   console.log('inner')
                        //   if(img.height != 154 && img.width != 1302 ) {
                        //     alert("Wrong Image dimentions, valid image dimention is 1302/154.");
                        //     setSelectedFooterImage(null);
                        //     return false;
                        //   }
                        //   setSelectedFooterImage(e.target.files[0]);
                        // };

                        setSelectedFooterImage(e.target.files[0]);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="row mt-3">
              <div className="col" style={{ textAlign: "right" }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onUpdate}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="card" style={{ padding: 10 }}>
            <div style={{ textAlign: "right" }}>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => setViewType("list")}
              >
                Back
              </button>
            </div>
            {/* <div className="row">
              <div className="col-lg-6 col-sm-12">
                <label>Upload and Display Background Image</label>
                {selectedBgImage && (
                  <div>
                    <img
                      alt="not found"
                      width={"250px"}
                      src={URL.createObjectURL(selectedBgImage)}
                    />
                    <br />
                    <button onClick={() => setSelectedBGImage(null)}>
                      Remove
                    </button>
                  </div>
                )}

                <br />
                <br />

                <input
                  type="file"
                  name="myImage"
                  onChange={(event) => {
                    console.log(event.target.files[0]);
                    setSelectedBGImage(event.target.files[0]);
                  }}
                />
              </div>
              <div className="col-lg-6 col-sm-12">
                <label>Upload and Display Footer Image</label>
                {selectedBgImage && (
                  <div>
                    <img
                      alt="not found"
                      width={"250px"}
                      src={URL.createObjectURL(selectedFooterImage)}
                    />
                    <br />
                    <button onClick={() => setSelectedFooterImage(null)}>
                      Remove
                    </button>
                  </div>
                )}

                <br />
                <br />

                <input
                  type="file"
                  name="myImage"
                  onChange={(event) => {
                    console.log(event.target.files[0]);
                    setSelectedFooterImage(event.target.files[0]);
                  }}
                />
              </div>
              
            </div> */}

            <div className="row mt-3">
              <div className="col-lg-3 col-sm-12">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.Title}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) => updateData("Title", e.target.value)}
                />
              </div>
              <div className="col-lg-9 col-sm-12">
                <label>Title Description</label>
                <textarea
                  className="form-control"
                  value={data.TitleDescription == null ? "": data.TitleDescription}
                  maxLength={2000}
                  onChange={(e) =>
                    updateData("TitleDescription", e.target.value)
                  }
                ></textarea>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-12 col-sm-12">
                <label>Banner Text</label>
                <textarea
                  className="form-control"
                  value={data.BannerText == null ? "": data.BannerText}
                  maxLength={2000}
                  onChange={(e) => updateData("BannerText", e.target.value)}
                ></textarea>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-3 col-sm-12">
                <label>Background Image Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.BgImageName == null ? "": data.BgImageName}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) => updateData("BgImageName", e.target.value)}
                />
              </div>

              <div className="col-lg-3 col-sm-12">
                <label>Background Image Opacity</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.BgImageOpacity}
                  onInput={processNum}
                  maxLength={3}
                  placeholder="Enter value between 0.0 to 1.0"
                  onChange={(e) => updateData("BgImageOpacity", e.target.value)}
                />
              </div>

              <div className="col-lg-3 col-sm-12">
                <label>Footer Image Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.FooterImageName == null ? "": data.FooterImageName}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) =>
                    updateData("FooterImageName", e.target.value)
                  }
                />
              </div>

              {/* <div className="col-lg-3 col-sm-12">
                <label>Footer Image Opacity</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.FooterImageOpacity}
                  onInput={processNum}
                  maxLength={3}
                  placeholder="Enter value between 0.0 to 1.0"
                  onChange={(e) =>
                    updateData("FooterImageOpacity", e.target.value)
                  }
                />
              </div> */}
            </div>

            <div className="row mt-3">
              <div className="col-lg-3 col-sm-12">
                <label>Font Color</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.FontColor == null ? "": data.FontColor}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) => updateData("FontColor", e.target.value)}
                />
              </div>

              <div className="col-lg-3 col-sm-12">
                <label>BackGround Color</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.BackgroundColor == null ? "": data.BackgroundColor}
                  onInput={processStrWithSpaceAndSpecalChars}
                  maxLength={49}
                  onChange={(e) =>
                    updateData("BackgroundColor", e.target.value)
                  }
                />
              </div>

              <div className="col-lg-3 col-sm-12">
                <label>Background Color Opacity</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.BgColorOpacity}
                  onInput={processNum}
                  maxLength={3}
                  placeholder="Enter value between 0.0 to 1.0"
                  onChange={(e) => updateData("BgColorOpacity", e.target.value)}
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-6 col-sm-12">
                <div className="col-lg-1 col-sm-12">
                  <label style={{ whiteSpace: "nowrap" }}>
                    Background Image
                  </label>
                  <br />
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={data.IsBgImage}
                      onChange={(e) =>
                        updateData("IsBgImage", e.target.checked)
                      }
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
                {data.IsBgImage && (
                  <div className="col-lg-6 col-sm-12">
                    <label>Upload and Display Background Image</label>
                    {selectedBgImage && (
                      <div>
                        <img
                          alt="not found"
                          width={"250px"}
                          src={URL.createObjectURL(selectedBgImage)}
                        />
                        <br />
                        <button onClick={() => setSelectedBGImage(null)}>
                          Remove
                        </button>
                      </div>
                    )}

                    <br />
                    <br />

                    <input
                      type="file"
                      name="myImage"
                      onChange={(e) => {
                        var fileInput = e;
                        var filePath = e.target.value;
                        // Allowing file type
                        var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
                        if (!allowedExtensions.exec(filePath)) {
                          alert("Invalid file type");
                          fileInput.target.value = "";
                          return false;
                        }

                        const fi = e.target;
                        // Maximum file size is 4 mb
                        if (fi.files.length > 0) {
                          for (let i = 0; i <= fi.files.length - 1; i++) {
                            const fsize = fi.files.item(i).size;
                            const file = Math.round(fsize / 1024);
                            // The size of the file.
                            if (file >= 4096) {
                              alert(
                                "File too Big, please select a file less than 4mb"
                              );
                              return false;
                            }
                          }
                        }

                        //checking dimention for banner and footer

                        // var img = document.createElement("img");
                        // img.src = URL.createObjectURL(e.target.files[0]);

                        // img.onload = function (event) {
                        //   console.log({ width: img.width, height: img.height });
                        //   console.log('inner')
                        //   if(img.height != 667 && img.width != 1000 ) {
                        //     alert("Wrong Image dimentions, valid image dimention is 1000/667.");
                        //     setSelectedBGImage(null);
                        //     return false;
                        //   }
                        //   setSelectedBGImage(e.target.files[0]);
                        // };

                        setSelectedBGImage(e.target.files[0]);
                      }}
                    />
                  </div>
                )}
              </div>

              <div className="col-lg-6 col-sm-12">
                <div className="col-lg-6 col-sm-12">
                  <label style={{ whiteSpace: "nowrap" }}>Footer Image</label>
                  <br />
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={data.IsFooterImage}
                      onChange={(e) =>
                        updateData("IsFooterImage", e.target.checked)
                      }
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
                {data.IsFooterImage && (
                  <div className="col-lg-6 col-sm-12">
                    <label>Upload and Display Footer Image</label>
                    {selectedFooterImage && (
                      <div>
                        <img
                          alt="not found"
                          width={"250px"}
                          src={URL.createObjectURL(selectedFooterImage)}
                        />
                        <br />
                        <button onClick={() => setSelectedFooterImage(null)}>
                          Remove
                        </button>
                      </div>
                    )}

                    <br />
                    <br />

                    <input
                      type="file"
                      name="myImage"
                      onChange={(e) => {
                        var fileInput = e;
                        var filePath = e.target.value;
                        // Allowing file type
                        var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
                        if (!allowedExtensions.exec(filePath)) {
                          alert("Invalid file type");
                          fileInput.target.value = "";
                          return false;
                        }

                        const fi = e.target;
                        // Maximum file size is 4 mb
                        if (fi.files.length > 0) {
                          for (let i = 0; i <= fi.files.length - 1; i++) {
                            const fsize = fi.files.item(i).size;
                            const file = Math.round(fsize / 1024);
                            // The size of the file.
                            if (file >= 4096) {
                              alert(
                                "File too Big, please select a file less than 4mb"
                              );
                              return false;
                            }
                          }
                        }

                        //checking dimention for banner and footer

                        // var img = document.createElement("img");
                        // img.src = URL.createObjectURL(e.target.files[0]);

                        // img.onload = function (event) {
                        //   console.log({ width: img.width, height: img.height });
                        //   console.log('inner')
                        //   if(img.height != 154 && img.width != 1302 ) {
                        //     alert("Wrong Image dimentions, valid image dimention is 1302/154.");
                        //     setSelectedFooterImage(null);
                        //     return false;
                        //   }
                        //   setSelectedFooterImage(e.target.files[0]);
                        // };

                        setSelectedFooterImage(e.target.files[0]);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="row mt-3">
              <div className="col" style={{ textAlign: "right" }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
      </section>
    )
  );
};

export default PortalBanner;
